module.exports = __webpack_public_path__ + "assets/196eb05b588258ccd9c86dd284a1c3f7.mp3";